// Utility to deeply filter out null, undefined, empty string (including whitespace-only), empty array, and empty object fields from provider_data
export function filterProviderData<T>(data: T): T {
  if (Array.isArray(data)) {
    // Recursively filter array elements and remove empty arrays
    const filtered = data
      .map(filterProviderData)
      .filter(
        (v) =>
          v !== null &&
          v !== undefined &&
          !(typeof v === 'string' && v.trim() === '') &&
          !(typeof v === 'string' && v.trim().toLowerCase() === 'none') &&
          !(Array.isArray(v) && v.length === 0) &&
          !(typeof v === 'object' && v && Object.keys(v).length === 0)
      );
    return filtered as unknown as T;
  }
  if (typeof data === 'object' && data !== null) {
    const result: any = {};
    for (const [key, value] of Object.entries(data)) {
      const filteredValue = filterProviderData(value);
      if (
        filteredValue !== null &&
        filteredValue !== undefined &&
        !(typeof filteredValue === 'string' && filteredValue.trim() === '') &&
        !(typeof filteredValue === 'string' && filteredValue.trim().toLowerCase() === 'none') &&
        !(Array.isArray(filteredValue) && filteredValue.length === 0) &&
        !(typeof filteredValue === 'object' && filteredValue && Object.keys(filteredValue).length === 0)
      ) {
        result[key] = filteredValue;
      }
    }
    return result as T;
  }
  // Translate English Yes/No to Swedish Ja/Nej
  if (typeof data === 'string' && data.trim().toLowerCase() === 'no') {
    return 'Nej' as unknown as T;
  }
  if (typeof data === 'string' && data.trim().toLowerCase() === 'yes') {
    return 'Ja' as unknown as T;
  }
  // Filter out "None" values and empty strings
  if (typeof data === 'string' && (data.trim() === '' || data.trim().toLowerCase() === 'none' || data.trim().toLowerCase() === 'unknown')) {
    return undefined as unknown as T;
  }
  return data;
}
